import { Estabelecimento } from '@/types/rede-credenciada';
import RedeCredenciadaListCard from './rede-credenciada-card';

interface RedeCredenciadaListPageProps {
  estabelecimentos: Estabelecimento[];
  loading?: boolean;
}

export default function RedeCredenciadaListPage({
  estabelecimentos,
  loading,
}: RedeCredenciadaListPageProps) {
  if (loading) {
    return (
      <div className="flex items-center justify-center w-full py-12">
        <div className="w-12 h-12 rounded-full border-4 border-t-[#0066B3] border-l-[#0066B3] border-r-[#CCCCCC] border-b-[#CCCCCC] animate-spin"></div>
      </div>
    );
  }

  if (estabelecimentos.length === 0) {
    return (
      <div className="flex flex-col w-full bg-[#0066B3] bg-opacity-10 border border-opacity-30 border-[#0066b3] rounded-lg py-6 items-center justify-center text-center">
        <p className="text-center text-bluecaixa">
          <b className="font-extrabold text-bluecaixa">
            Nenhum resultado encontrado!
          </b>{' '}
          Preencha o CEP no campo ao lado para consultar
        </p>
      </div>
    );
  }

  return (
    /* Lista de cartões de estabelecimentos 2x2 */
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {estabelecimentos.map((estabelecimento) => (
        <RedeCredenciadaListCard
          key={estabelecimento.nome}
          estabelecimento={estabelecimento}
        />
      ))}
    </div>
  );
}
